$(document).ready(function(){
  if($(window).width() < 750){
    $('.ats-blocks-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 300,
      infinite: true,
      autoplaySpeed: 3000,
      autoplay: true,
      centerMode: true,
      centerPadding: '150px',
      responsive: [
        {
          breakpoint: 480,
          settings: {
            centerPadding: '75px',
          }
        },
        {
          breakpoint: 395,
          settings: {
            centerPadding: '50px',
          }
        }
      ]
    });
  } else {
     $('.ats-blocks-wrapper').slick('unslick');
  }
});